import React from 'react';
const InvoiceHeader = ({ 
  docType, setDocType, 
  docno, 
  invoiceDate, setInvoiceDate, 
  customers, customerCode, setCustomerCode, 
  poNumber, setPoNumber, 
  poDate, setPoDate,
  taxApplicable, setTaxApplicable // <-- Add new props here
}) => {
  return (
    <div className="invoice-header">
      {/* Document Type */}
      <div className="form-group doc-type">
        <label>Document Type</label>
        <select value={docType} onChange={(e) => setDocType(e.target.value)}>
          <option value="INVOICE">Invoice</option>
          <option value="ESTIMATE">Estimate</option>
          <option value="DC">Delivery Challan</option>
        </select>
      </div>

      {/* Document No. */}
      <div className="form-group doc-number">
        <label>Document No.</label>
        <input type="text" value={docno} readOnly disabled />
      </div>

      {/* Customer */}
      <div className="form-group customer-select">
        <label>Customer</label>
        <select value={customerCode} onChange={(e) => setCustomerCode(e.target.value)}>
          <option value="">Select a customer</option>
          {customers.map((c) => (
            <option key={c.customercode} value={c.customercode}>{c.customername}</option>
          ))}
        </select>
      </div>

      {/* Date */}
      <div className="form-group">
        <label>Date</label>
        <input type="date" value={invoiceDate} onChange={(e) => setInvoiceDate(e.target.value)} />
      </div>

      {/* PO No. */}
      <div className="form-group">
        <label>PO No.</label>
        <input value={poNumber} onChange={(e) => setPoNumber(e.target.value)} />
      </div>

      {/* PO Date */}
      <div className="form-group">
        <label>PO Date</label>
        <input type="date" value={poDate} onChange={(e) => setPoDate(e.target.value)} />
      </div>
      
      {/* --- NEW APPLY TAX CHECKBOX --- */}
      <div className="apply-tax" style={{ marginTop: 10 }}>
  <input
    id="applyTax"
    type="checkbox"
    checked={taxApplicable}
    onChange={(e) => setTaxApplicable(e.target.checked)}
  />
  <label htmlFor="applyTax">Apply Tax</label>
</div>
      {/* --- END OF NEW CODE --- */}
    </div>
  );
};

export default InvoiceHeader;